import React from "react"
import styles from "./savings-club.module.css"

const SavingsClub = () => {
  return (
    <div className={styles.savings}>
      <div className={styles.commonHeader}>
        <h1 className={styles.commonHeading}>Savings Club</h1>
        <div className={styles.underline}>
          <div className={styles.smallUnderline}/>
          <div className={styles.largeUnderline}/>
        </div>
      </div>

      <div className="container">
        <div className='mt-5'>
          <p className='p-3 h4 text-center'>
            We operate a popular year round savings club. It enables you to spread the cost of your little one. Items
            can
            only be taken once they have been paid for in full.</p>
          <h3 className='text-center'>
            <u>How does it work?</u></h3>
          <p className='p-3 h4'>
            <strong>New items: </strong>
            You have no time restriction on how long it takes you to pay off these items. Once half the amount has been
            paid the item will then be placed on order.</p>
          <p className='p-3 h4'>
            <strong>Factory Seconds: </strong>
            You have 4 weeks to pay the full amount off and collect the item.</p>

          <p className='p-3 h4 text-center'><strong>A minimum amount of £10 is required as a deposit and is non
            refundable
            and non
            transferable.</strong>
          </p>
        </div>
      </div>

    </div>
  )
}

export default SavingsClub
